import React from "react";
import {
  FaReact,
  FaNodeJs,
  FaFigma,
  FaPython,
  FaAndroid,
  FaSearch,
  FaDatabase,
  FaCode,
} from "react-icons/fa";
import { useNavigate } from "react-router-dom";

import "./FeaturedPosts.css";

const skills = [
  {
    icon: <FaFigma />,
    name: "UI/UX Design",
    path: "/ui-ux-design",
  },
  {
    icon: <FaReact />,
    name: "Frontend",
    path: "/frontend-development",
  },
  {
    icon: <FaNodeJs />,
    name: "Backend",
    path: "/backend-development",
  },
  {
    icon: <FaCode />,
    name: "Full Stack",
    path: "/full-stack-development",
  },
  {
    icon: <FaAndroid />,
    name: "Mobile Apps",
    path: "/mobile-app-development",
  },
  {
    icon: <FaPython />,
    name: "Data Science",
    path: "/data-science",
  },
  {
    icon: <FaDatabase />,
    name: "DSA",
    path: "/dsa-algorithms",
  },
  {
    icon: <FaSearch />,
    name: "SEO",
    path: "/seo-digital-marketing",
  },
];

export default function FeaturedPosts() {
  const navigate = useNavigate();

  return (
    <section className="skills-strip">
      <div className="skills-track">
        {[...skills, ...skills].map((skill, index) => (
          <div
            key={index}
            className="skill-item"
            onClick={() => navigate(skill.path)}
          >
            {skill.icon}
            <span>{skill.name}</span>
          </div>
        ))}
      </div>
    </section>
  );
}